// Identificador ANÓNIMO del navegador para "visitantes únicos" de analytics
// (2026-10-16). Un UUID que se genera una vez, queda en localStorage y viaja
// en cada `POST /analytics/track`. No identifica a la persona: identifica al
// navegador, que es lo que hace falta para no contar diez veces al mismo
// comprador que abrió diez fichas. Sin cookies de terceros ni datos personales.
//
// Antes se contaba por IP, y la IP miente para los dos lados: una oficina
// entera detrás de un router es UNA ip, y un celular con IPv6 cambia de
// dirección varias veces al día y cuenta como varias personas.
//
// Todo va en try/catch: en modo privado, con el storage bloqueado o adentro
// de un iframe de terceros `localStorage` puede tirar. Ahí se devuelve un id
// nuevo por carga (cuenta de más, nunca rompe la ficha) — el backend acepta
// `null` también, y esa fila cae a la IP.
const CLAVE = 'puja_visitante';

const generar = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Navegadores viejos: 32 hex sin guiones. El backend acepta de 8 a 36
  // caracteres alfanuméricos.
  return `${Date.now().toString(16)}${Math.random().toString(16).slice(2, 10)}${Math.random().toString(16).slice(2, 10)}`.slice(0, 36);
};

export const idVisitante = () => {
  try {
    const guardado = localStorage.getItem(CLAVE);
    if (guardado) return guardado;
    const nuevo = generar();
    localStorage.setItem(CLAVE, nuevo);
    return nuevo;
  } catch {
    return generar();
  }
};
